import React from "react";

const Constructor_Overloading = () => {
  return (
    <div>
      <h1>Constructor_Overloading Component</h1>
      <p>Content for Constructor_Overloading goes here...</p>
    </div>
  );
};

export default Constructor_Overloading;
